export default{
    __bsi_SeeAll:"登録",
    __asi_SeeAll:"全て",
    __CasinoSectionTitle: "ライブカジノ"
}